import React from "react"
import {FunctionComponent} from "react"
import LevelView from "./components/LevelView"
import ComponentWrapper from "../../common/components/ComponentWrapper"

interface TMSLevelViewProps {
	isLevelView: boolean
}

const TMSLevelView: FunctionComponent<TMSLevelViewProps> = ({isLevelView}) => {
	return (
		<ComponentWrapper active={3} subMenuActive={isLevelView ? 2 : 3}>
			<LevelView levelView={isLevelView} />
		</ComponentWrapper>
	)
}

export default TMSLevelView
